import { Routes, Route } from 'react-router-dom';

import Steward from '../pages/steward';

import LandingPage from '../pages/landingPage';
import POSTouch from '../components/posTouch';

import Room from '../pages/room';
import Guest from '../pages/guest';

export default function App() {
    return (
        <>
            <Routes>
                <Route path="*" element={<LandingPage />}></Route>
                <Route path="/steward/*" element={<Steward />}></Route>
                <Route path="/postouch" element={<POSTouch />}></Route>
                <Route path="/room/*" element={<Room />}></Route>
                <Route path="/guest/*" element={<Guest />}></Route>
            </Routes>
        </>
    )
}